(ns shared.core.components.modals.data
  (:require [shared.core.reactive :as re]))

(def root-path [:modals])
(def active-path (conj root-path :active))

(defn active-modals [db]
  (get-in db active-path []))

(re/reg-event-db
  :modals/show re/middleware
  (fn [db [modal]]
    (re/dispatch [:keybind/pause-current-route-bindings])
    (assoc-in db active-path [modal])))

(re/reg-event-db
  :modals/show-with-form-init re/middleware
  (fn [db [modal form-path form-vals]]
    (re/dispatch [:modals/show modal])
    (re/dispatch [:form/init form-path form-vals])
    db))

(re/reg-event-db
  :modals/show-stacked re/middleware
  (fn [db [modal]]
    (re/dispatch [:keybind/pause-current-route-bindings])
    (assoc-in db active-path (-> (active-modals db) (concat [modal]) (vec)))))

(re/reg-event-db
  :modals/hide re/middleware
  (fn [db]
    (re/dispatch [:keybind/resume-current-route-bindings])
    (assoc-in db active-path (-> (active-modals db) (drop-last) (vec)))))

(re/reg-event-db
  :modals/scroll-to-top re/middleware
  (fn [db]
    (when-let [modal-el (.querySelector js/document "[data-modal]")]
      (set! (.-scrollTop modal-el) 0))
    db))

(defn active-modal [db]
  (some-> (active-modals db) (last)))

(re/reg-sub :modals/active- active-modal)

(re/reg-sub :modals/all-active- active-modals)
